import React from 'react';
import styled from 'styled-components';

import ColorConstants from '../../../constants/ColorConstants';

const CloseToastButton = () => <Button><CloseButtonWrapper /></Button>;

const CloseButtonWrapper = () => (
    <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M13 24.75C19.4893 24.75 24.75 19.4893 24.75 13C24.75 6.51065 19.4893 1.25 13 1.25C6.51065 1.25 1.25 6.51065 1.25 13C1.25 19.4893 6.51065 24.75 13 24.75Z" stroke="white" />
        <path d="M10.2461 10.249L16.1046 16.1075" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16.1046 10.249L10.2461 16.1075" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>

);
const Button = styled.button`
    background-color: transparent;
    color: ${ColorConstants.white};
    font-size: 17px;
    font-weight: bold;
    left: -34px;
    height: 26px;
    position: relative;
    top: 10px;
    
    &:hover {
        opacity: 0.8;
    }
`;

export default CloseToastButton;
